var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "auth-main" }, [
    _c(
      "main",
      { staticClass: "main--login", attrs: { id: "main" } },
      [
        _c(
          "section",
          { staticClass: "section-login" },
          [
            _c("Header", { attrs: { "is-whitelabel": _vm.isWhitelabel } }),
            _vm._v(" "),
            _c("div", { staticClass: "login-form-wrapper" }, [
              _c(
                "div",
                { staticClass: "loginv2-container p-b-20" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", {
                      staticClass: "login_logo",
                      class: { "login_logo--ringba": !_vm.isWhitelabel }
                    })
                  ]),
                  _vm._v(" "),
                  !_vm.inviteStatus.isInvitationValid
                    ? _c("InvalidInvite", {
                        attrs: { "invite-status": _vm.inviteStatus }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.inviteStatus.isInvitationValid &&
                  _vm.inviteStatus.userExists
                    ? _c("JoinExistingUser")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.inviteStatus.isInvitationValid &&
                  !_vm.inviteStatus.userExists
                    ? _c("JoinORPInviteForm", {
                        attrs: {
                          "applicant-name": _vm.applicantName,
                          "applicant-type": _vm.applicantType,
                          "account-name": _vm.inviteData.accountName,
                          "action-status": _vm.actionStatus
                        },
                        on: { "join-orp-invite": _vm.onJoinInvite }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isWhitelabel ? _c("Footer") : _vm._e(),
        _vm._v(" "),
        _vm.isWhitelabel ? _c("WhitelabelFooter") : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }